var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file Popover
 * @author (zhuwanying02)
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import PopperWrap from '../PopperWrap';
import _ from 'lodash-es';
import { classPrefix } from '../../common/util';

import './Popover.less';

/*
 * 参数说明
 * trigger                      非必需，唤起方式click/hover
 * panelLocation                非必需，弹出框方向的16个取值: tlc(= tl), tl, t, tr, trc(= tr),
 *                                 rt, r, rb, blc(= bl), bl, b, br, brc(= br), lt, l, lb。默认rt
 * withOperation                非必需，是否带操作按钮
 * operations                   非必需，带操作按钮时的配置项，okText/cancelText/handleOperation
 * children                     必需，总是展示的内容，通过click/hover触发唤起弹出框的区域
 * content                      必需，弹出框里的内容
 * title                        非必需，弹出框里的标题
 * className                    非必需，组件根元素上传入自定义类，字符串
 * classPrefix                  非必需，类名前缀，默认为'spui'
 * style                        非必需，根元素上添加样式
 * zIndex                       非必需，弹出层的z-index值
 * onlyBodyClickFoldPopover     非必需，只有点击组件外的区域收起Popover
 * isShowPanel                  非必需，控制Popover展开状态
 * trigger                      非必需，唤起方式click/hover，默认'click'
 * preventOverflowEnabled       非必需,是否受overflow碰撞影响
 * control                      非必需,是否由属性isShowPanel控制
 * onCloseByWindow              非必需,点击组件外区域的回调函数
 * popupNodeClassName           非必需,弹出层最外层className
 * popupOnBody                  可选,下拉是否挂在body上
 */

var Popover = function (_Component) {
    _inherits(Popover, _Component);

    function Popover(props) {
        _classCallCheck(this, Popover);

        var _this = _possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).call(this, props));

        _this.onCloseByWindow = function () {
            _this.setState({
                isShowPanel: false
            }, function () {
                var onCloseByWindow = _this.props.onCloseByWindow;
                _.isFunction(onCloseByWindow) && onCloseByWindow();
            });
        };

        _this.togglePopoverVisible = function () {
            var _this$props = _this.props,
                trigger = _this$props.trigger,
                onlyBodyClickFoldPopover = _this$props.onlyBodyClickFoldPopover;

            if (onlyBodyClickFoldPopover && _this.state.isShowPanel || trigger === 'hover') {
                return;
            }
            _this.setState({
                isShowPanel: !_this.state.isShowPanel
            });
        };

        _this.handleCancel = function () {
            var _this$props2 = _this.props,
                withOperation = _this$props2.withOperation,
                operations = _this$props2.operations;

            if (withOperation && operations.handleOperation) {
                operations.handleOperation('cancel');
            }
            _this.setState({
                isShowPanel: false
            });
        };

        _this.handleOk = function () {
            var _this$props3 = _this.props,
                withOperation = _this$props3.withOperation,
                operations = _this$props3.operations;

            if (withOperation && operations.handleOperation) {
                operations.handleOperation('ok');
            }
            _this.setState({
                isShowPanel: false
            });
        };

        _this.handleMouseEnter = function () {
            if (_this.props.trigger === 'hover') {
                _this.setState({
                    isShowPanel: true
                });
            }
            // 每次鼠标移入重新计算弹出层位置
            _this.PopperWrap.update();
        };

        _this.handleMouseLeave = function () {
            if (_this.props.trigger === 'hover') {
                _this.setState({
                    isShowPanel: false
                });
            }
        };

        _this.POPOVER_WIDTH = 380;

        _this.state = {
            isShowPanel: _this.props.isShowPanel
        };
        return _this;
    }

    _createClass(Popover, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(np) {
            if (np.control) {
                this.setState({
                    isShowPanel: np.isShowPanel
                });
            }
        }
    }, {
        key: 'renderOperation',
        value: function renderOperation() {
            var _props = this.props,
                classPrefix = _props.classPrefix,
                operations = _props.operations;

            var prefixCls = classPrefix + '-popover';
            var okText = operations.okText || '确定';
            return React.createElement(
                'div',
                { className: prefixCls + '-panel-operation' },
                operations.cancelText && React.createElement(
                    'div',
                    { className: prefixCls + '-panel-operation-cancel', onClick: this.handleCancel },
                    operations.cancelText
                ),
                React.createElement(
                    'div',
                    { className: prefixCls + '-panel-operation-ok', onClick: this.handleOk },
                    okText
                )
            );
        }
    }, {
        key: 'popperNeedPlacement',
        value: function popperNeedPlacement(panelLocation) {
            switch (panelLocation) {
                case 't':
                    return 'top';
                case 'tl':
                    return 'top-start';
                case 'tr':
                    return 'top-end';
                case 'b':
                    return 'bottom';
                case 'bl':
                    return 'bottom-start';
                case 'br':
                    return 'bottom-end';
                case 'r':
                    return 'right';
                case 'rt':
                    return 'right-start';
                case 'rb':
                    return 'right-end';
                case 'l':
                    return 'left';
                case 'lt':
                    return 'left-start';
                case 'lb':
                    return 'left-end';
                default:
                    return 'right-start';
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _classnames2,
                _this2 = this;

            var _props2 = this.props,
                trigger = _props2.trigger,
                style = _props2.style,
                className = _props2.className,
                title = _props2.title,
                content = _props2.content,
                children = _props2.children,
                panelLocation = _props2.panelLocation,
                classPrefix = _props2.classPrefix,
                withOperation = _props2.withOperation,
                zIndex = _props2.zIndex,
                preventOverflowEnabled = _props2.preventOverflowEnabled,
                popupNodeClassName = _props2.popupNodeClassName,
                popupOnBody = _props2.popupOnBody;

            var prefixCls = classPrefix + '-popover';
            var dClass = classnames(className, (_classnames = {}, _defineProperty(_classnames, prefixCls, true), _defineProperty(_classnames, prefixCls + '-hover', trigger === 'hover'), _defineProperty(_classnames, prefixCls + '-click', trigger === 'click'), _classnames));
            // 目前暂不处理带c的位置，默认去掉c
            var panelLocationFormat = panelLocation.split('c')[0];
            var panelWrapperClass = classnames((_classnames2 = {}, _defineProperty(_classnames2, prefixCls + '-panel-wrapper', true), _defineProperty(_classnames2, prefixCls + '-panel-wrapper-' + panelLocationFormat, true), _classnames2));

            return React.createElement(PopperWrap, {
                ref: function ref(el) {
                    _this2.PopperWrap = el;
                },
                containerNode: React.createElement(
                    'div',
                    {
                        ref: function ref(el) {
                            _this2.dpContainer = el;
                        },
                        className: dClass,
                        style: style
                    },
                    React.createElement(
                        'div',
                        {
                            onClick: this.togglePopoverVisible,
                            onMouseEnter: this.handleMouseEnter,
                            onMouseLeave: this.handleMouseLeave
                        },
                        children
                    )
                ),
                popupNode: React.createElement(
                    'div',
                    {
                        className: prefixCls + '-panel-container',
                        onMouseEnter: this.handleMouseEnter,
                        onMouseLeave: this.handleMouseLeave
                    },
                    React.createElement(
                        'div',
                        { className: panelWrapperClass },
                        title && React.createElement(
                            'h3',
                            { className: prefixCls + '-panel-title' },
                            title
                        ),
                        React.createElement(
                            'div',
                            { className: prefixCls + '-panel-content' },
                            content
                        ),
                        withOperation && this.renderOperation()
                    )
                ),
                isShowPopup: this.state.isShowPanel,
                onBodyClick: this.onCloseByWindow,
                popupNodeZIndex: zIndex,
                popupNodeClassName: popupNodeClassName,
                placement: this.popperNeedPlacement(panelLocationFormat),
                preventOverflowEnabled: preventOverflowEnabled,
                popupOnBody: popupOnBody
            });
        }
    }]);

    return Popover;
}(Component);

Popover.defaultProps = {
    trigger: 'click',
    classPrefix: classPrefix,
    withOperation: false,
    operations: {},
    panelLocation: 'rt',
    onlyBodyClickFoldPopover: false,
    preventOverflowEnabled: true,
    popupOnBody: true
};
Popover.propTypes = {
    trigger: PropTypes.oneOf(['hover', 'click']),
    classPrefix: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    zIndex: PropTypes.number,
    withOperation: PropTypes.bool,
    operations: PropTypes.object,
    panelLocation: PropTypes.string,
    children: PropTypes.node.isRequired,
    content: PropTypes.node.isRequired,
    title: PropTypes.node,
    className: PropTypes.string,
    style: PropTypes.object,
    onlyBodyClickFoldPopover: PropTypes.bool,
    isShowPanel: PropTypes.bool,
    preventOverflowEnabled: PropTypes.bool,
    control: PropTypes.bool,
    onCloseByWindow: PropTypes.func,
    popupNodeClassName: PropTypes.string,
    popupOnBody: PropTypes.bool
};
export default Popover;